import Api from "../../../services/Api";
import { validateLoginPayload } from "../../../lib/utils/apiValidation";

export function loginUser(credentials) {
  const payload = validateLoginPayload(credentials);
  return Api.post(`/service/iqevse-csms/auth/v1/login`, payload);
}
